import { createWebHistory, createRouter } from "vue-router";
import RenderView from '../components/RenderView.vue';
import View2D from '../components/View2D.vue';

const routes = [
  { name: '2D', path: '/', component: View2D},
  { name: '3D', path: '/3d/', component: RenderView},
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;